<template>
    <div class="submenu_permission">
        <div class="background-shapes">
            <div class="shape triangle-1"></div>
            <div class="shape triangle-2"></div>
            <div class="shape circle"></div>
        </div>
        <div class="row menu-form">

            <div class="col-12 mb-3">
                <b-card class="rounded text-white bg-primary shadow-lg">
                    <h3 class="mb-0">{{$t('Bank Or Branch Entry')}}</h3>
                </b-card>
            </div>
            <!--<div class="col-md-6 mt-2">
                <b-form-radio-group
                        id=""
                        v-model="bankBranch"
                        :options="options"
                        name=""
                        buttons
                ></b-form-radio-group>
            </div>-->
            <div class="col-md-12">
                <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" class="mt-4">
                    <div class="col-12">
                        <b-card class="p-4">
                            <div class="row">
                                <div class="col-md-6 mb-3 text-success">
                                    <b-form-group id="Bank" :label='$t("Bank")' label-for="Bank" v-if="isEdit || bankList">
                                        <b-form-select
                                                v-if="lang != 'bn'"
                                                v-model="form.bankId"
                                                :options="bankList"
                                                class="mb-3"
                                                value-field="bankId"
                                                text-field="bankEn"
                                                @change="branchData"
                                                disabled-field="notEnabled"
                                        >
                                            <option :value="1">{{$t("Others")}}</option>
                                            <option value="" selected>{{$t('Select One')}}</option>
                                        </b-form-select>
                                        <b-form-select
                                                v-else
                                                v-model="form.bankId"
                                                :options="bankList"
                                                class="mb-3"
                                                value-field="bankId"
                                                text-field="bankBn"
                                                @change="branchData"
                                                disabled-field="notEnabled"
                                        >
                                            <option :value="1">{{ $t('Others') }}</option>
                                            <option value="" selected>{{$t("Select One")}}</option>
                                        </b-form-select>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6 text-success" v-if="form.bankId !== 1">
                                    <b-form-group
                                            id="Branch"
                                            :label="$t('Branch')"
                                            label-for="Branch"
                                    >
                                        <b-form-select
                                                v-if="lang != 'bn'"
                                                v-model="form.branchId"
                                                :options="branchLists || []"
                                                class="mb-3"
                                                value-field="branchId"
                                                text-field="branchNameEn"
                                        >
                                            <option :value="2">{{$t('Others')}}</option>
                                            <option value="" selected>{{$t('Select One')}}</option>
                                        </b-form-select>
                                        <b-form-select
                                                v-else
                                                v-model="form.branchId"
                                                :options="branchLists || []"
                                                class="mb-3"
                                                value-field="branchId"
                                                text-field="branchNameBn"
                                        >
                                            <option :value="2">{{$t('Others')}}</option>
                                            <option value="" selected>{{$t('Select One')}}</option>
                                        </b-form-select>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6 mb-3 text-success" v-if="form.branchId == 2">
                                    <b-form-group :label="$t('Branch Name')" label-for="branch-name">
                                        <b-form-input
                                                id="branch-name"
                                                v-model="form.branchEn"
                                                required
                                                :placeholder="$t('Branch Name')"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6 mb-3 text-success" v-if="form.bankId == 1 || isEdit">
                                    <b-form-group :label="$t('Bank Name')" label-for="branch-name">
                                        <b-form-input
                                                id="branch-name"
                                                v-model="form.bankEn"
                                                required
                                                :placeholder="$t('Bank Name')"
                                        />
                                    </b-form-group>
                                </div>

                                <div class="col-md-6 mb-3 text-success" v-if="form.branchId == 2">
                                    <b-form-group :label="$t('Branch Name Bangla')" label-for="branch-name">
                                        <b-form-input
                                                id="branch-name"
                                                v-model="form.branchBn"
                                                required
                                                :placeholder="$t('Branch Name Bangla')"
                                        />
                                    </b-form-group>
                                </div>
                                <div class="col-md-6 mb-3 text-success" v-if="form.bankId == 1 || isEdit">
                                    <b-form-group :label="$t('Bank Name Bangla')" label-for="branch-name">
                                        <b-form-input
                                                id="branch-name"
                                                v-model="form.bankBn"
                                                required
                                                :placeholder="$t('Bank Name Bangla')"
                                        />
                                    </b-form-group>
                                </div>
                                <!--<div class="col-md-6 mb-3 text-success">
                                    <b-form-group label="Branch Code" label-for="branch-code">
                                        <b-form-input
                                                id="branch-code"
                                                v-model="form.branchCode"
                                                placeholder="Enter branch code"
                                        />
                                    </b-form-group>
                                </div>

                                <div class="col-md-6 mb-3 text-success">
                                    <b-form-group label="Address" label-for="branch-address">
                                        <b-form-textarea
                                                id="branch-address"
                                                v-model="form.address"
                                                rows="2"
                                                placeholder="Enter branch address"
                                        />
                                    </b-form-group>
                                </div>-->

                                <div class="col-md-6 text-success" v-if="form.bankId == 1 || isEdit">
                                    <b-form-group
                                            :label="$t('Status')"
                                            v-slot="{ ariaDescribedby }"
                                            label-for="radios-btn-default" class="">

                                        <b-form-radio-group
                                                id="btn-radios-1"
                                                v-model="form.bankActiveYn"
                                                :options="optionsStatus"
                                                :aria-describedby="ariaDescribedby"
                                                :button-variant="(form.bankActiveYn=='N')?'outline-danger':'outline-success'"
                                                name="active_status"
                                                buttons
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6 text-success" v-if="form.branchId == 2">
                                    <b-form-group
                                            :label="$t('Status')"
                                            v-slot="{ ariaDescribedby }"
                                            label-for="radios-btn-default" class="">

                                        <b-form-radio-group
                                                id="btn-radios-1"
                                                v-model="form.branchActiveYn"
                                                :options="optionsStatus"
                                                :aria-describedby="ariaDescribedby"
                                                :button-variant="(form.branchActiveYn=='N')?'outline-danger':'outline-success'"
                                                name="active_status"
                                                buttons
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end gap-2">
                                <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
                                <b-button type="reset" variant="outline-secondary">{{$t('Clear')}}</b-button>
                            </div>
                        </b-card>
                    </div>
                </b-form>
                <div class="card p-4 mt-4">
                    <h5 class="bg-success p-3 rounded text-white fw-bold text-uppercase">{{$t('Bank List')}}</h5>
                    <div class="card-body mt-4 col-md-12" v-if="bankList.length > 0">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th v-for="(header, index) in headers" :key="index">
                                    {{ header.text }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in paginatedItems" :key="item.requestKey">
                                <td v-for="(header, hIndex) in headers" :key="hIndex">
                                    <template v-if="header.value === 'activeYn'">
                                        <span>{{ item.activeYn === 'Y' ? 'Active' : 'Inactive' }}</span>
                                    </template>
                                    <template v-else-if="header.value === 'action2'">
                                        <a class="btn text-dark" @click="editItemBank(item)">
                                            <font-awesome-icon icon="pen-to-square"/>
                                        </a>
                                    </template>
                                    <template v-else>
                                        {{ item[header.value] }}
                                    </template>
                                </td>
                            </tr>
                            <div class="d-flex justify-content-between align-items-center mt-3">
                                <b-button class="btn btn-outline-success" :disabled="currentPage === 1"
                                          @click="currentPage--">Previous
                                </b-button>

                                <span>Page {{ currentPage }} of {{ totalPages }}</span>

                                <b-button class="btn btn-outline-success" :disabled="currentPage === totalPages"
                                          @click="currentPage++">Next
                                </b-button>
                            </div>


                            </tbody>
                        </table>
                    </div>
                    <div class="border text-center" v-else>
                        {{$t('Data Not Found')}} !!
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import apiRepository from "@/services/ApiRepository";
    import {toast} from "vue3-toastify"

    export default {
        name: 'branchAdd',
        data() {
            return {
                form: {
                    bankId: '',
                    bankEn: '',
                    bankBn: '',
                    bankActiveYn: 'Y',
                    branchActiveYn: '',
                    branchId: '',
                    branchEn: '',
                    branchBn: '',
                },
                isEdit: false,
                radioSelection: null,
                headers: [
                    {text: this.$t('Bank Name'), value: 'bankEn'},
                    {text: this.$t('Bank Name Bangla'), value: 'bankBn'},
                    {text: this.$t('Action'), value: 'action2'},
                ],
                /*options: [
                               {text: 'Add Bank', value: '1'},
                               {text: 'Add Branch', value: '2'},
                           ],*/
                branchLists: [],
                bankList: [],
                currentPage: 1,
                perPage: 5,
                lang: '',
                optionsStatus: [
                    {text: this.$t('Active'), value: 'Y'},
                    {text: this.$t('Inactive'), value: 'N'},
                ],
            }

        },
        watch: {
            'form.bankId'(newVal) {
                if (newVal == 1 && this.form.branchId == 2) {
                    this.form.branchId = null;
                }
            },
            'form.branchId'(newVal) {
                if (newVal == 2 && this.form.bankId == 1) {
                    this.form.bankId = null;
                }
            }
        },
        mounted() {
            this.bankDataGet();
            this.lang = this.$store.state.lang

        },
        computed: {
            paginatedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.bankList.slice(start, end);
            },

            totalPages() {
                return Math.ceil(this.bankList.length / this.perPage);
            }
        },
        methods: {

            onSubmit() {
                let payload = {};

                if (this.form.bankId === 1) {
                    payload = {
                        bankId: (this.form.bankId === 1 || this.form.bankId === 2) ? null : this.form.bankId,
                        branchId: this.form.branchId,
                        bankNameEn: this.form.bankEn,
                        bankNameBn: this.form.bankBn,
                        branchNameEn: this.form.branchEn,
                        branchNameBn: this.form.branchEn,
                        bankActiveYn: this.form.bankActiveYn,
                        branchActiveYn: this.form.branchActiveYn,
                        other: this.form.bankId,

                    };
                } else {
                    payload = {
                        bankId: this.form.bankId,
                        branchId: this.form.branchId,
                        branchNameEn: this.form.branchEn,
                        branchNameBn: this.form.branchEn,
                        branchActiveYn: this.form.branchActiveYn,
                        other: this.form.branchId
                    };
                }

                apiRepository.saveBankBranch(payload).then((res) => {
                    if (res) {
                        toast.success(res.data)
                        this.bankDataGet();
                        this.onReset();
                    }
                }).catch((error) => {
                    toast.error(error.response?.data);
                });
            },

            /*onSubmit() {
                if (this.form.bankId === 1) {
                    const payload =
                        {
                            bankId: (this.form.bankId === 1 || this.form.bankId === 2) ? null : this.form.bankId,
                            branchId: this.form.branchId,
                            bankNameEn: this.form.bankEn,
                            bankNameBn: this.form.bankBn,
                            branchNameEn: this.form.branchEn,
                            branchNameBn: this.form.branchEn,
                            bankActiveYn: this.form.bankActiveYn,
                            branchActiveYn: this.form.branchActiveYn,
                            other: this.form.bankId
                        }
                } else {
                    const payload =
                        {
                            branchId: (this.form.bankId === 1 || this.form.bankId === 2) ? null : this.form.bankId,
                            bankNameEn: this.form.bankEn,
                            bankNameBn: this.form.bankBn,
                            branchNameEn: this.form.branchEn,
                            branchNameBn: this.form.branchEn,
                            bankActiveYn: this.form.bankActiveYn,
                            branchActiveYn: this.form.branchActiveYn,
                            other: this.form.branchId,
                        }

                }

                apiRepository.saveBankBranch(payload).then((res) => {
                    if (res) {
                        console.log(res.data || 'what to do!')
                    }
                }).catch((error) => {
                    toast.error(error.response?.data)
                })
            },*/
            editItemBank(item) {
                this.form = {
                    ...item,
                    bankId: item.bankId,
                    bankEn: item.bankEn,
                    bankBn: item.bankBn,
                    bankActiveYn: item.bankActiveYn
                }
                this.isEdit = true;
            },
            motherNidAttach(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.parentInfo.motherNIDFile = reader.result;
                    };
                }
            },
            bankDataGet() {
                apiRepository.getBankList().then((response) => {
                    if (response.data) {
                        this.bankList = response.data
                    } else {
                        console.error("Invalid response structure:", response.data);
                    }
                })
                    .catch((error) => {
                        console.error("Error fetching marital data:", error);
                    });
            },

            branchData(bankId) {
                if (bankId == 1 || bankId == 2) {
                    console.log("data", bankId)
                    return;
                } else {
                    apiRepository.getBranchList(bankId).then((response) => {
                        if (response) {
                            this.branchLists = response.data;
                        } else {
                            console.error("Invalid response structure");
                            this.branchLists = [];
                        }
                    }).catch((e) => {
                        console.error("Error fetching branch data:", e);
                        this.branchLists = [];
                    });
                }

            },
            onReset() {
                this.form = {
                    bankId: null,
                    bankEn: '',
                    bankBn: '',
                    bankActiveYn: 'Y',
                    branchActiveYn: '',
                    branchId: null,
                    branchEn: '',
                    branchBn: '',
                }
                this.isEdit = ''
            }
        }
    }
</script>

<style scoped>
    /*background style*/
    .submenu_permission {
        position: relative;
        padding: 2rem;
        background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
        border-radius: 15px;
        overflow: hidden;
    }

    .background-shapes {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .shape {
        position: absolute;
        background: rgba(255, 255, 255, 0.3);
    }

    .triangle-1 {
        width: 0;
        height: 0;
        border-left: 100px solid transparent;
        border-right: 100px solid transparent;
        border-bottom: 200px solid rgba(255, 99, 71, 0.3);
        top: -50px;
        left: -50px;
        transform: rotate(45deg);
    }

    .triangle-2 {
        width: 0;
        height: 0;
        border-left: 80px solid transparent;
        border-right: 80px solid transparent;
        border-bottom: 160px solid rgba(70, 130, 180, 0.3);
        bottom: -80px;
        right: -80px;
        transform: rotate(-30deg);
    }

    .circle {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: rgba(144, 238, 144, 0.3);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .menu-form {
        position: relative;
        z-index: 2;
        /*background: rgba(255, 255, 255, 0.9);*/
        padding: 2rem;
        border-radius: 10px;
        /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
        animation: fadeIn 0.5s ease-in-out;
    }

    .table th,
    .table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
        text-align: left !important;
    }

</style>